// src/components/filings/FilingsFeed.jsx
import React from 'react';
import FilingRow from './FilingRow';
import FilingLockedRow from './FilingLockedRow';

export default function FilingsFeed({ filings, total, page, pageSize, loading, error, onPageChange, onNavigate, onSignIn }) {
  if (loading) {
    return <div style={{ textAlign: 'center', padding: '3rem', color: '#64748b' }}>Loading filings…</div>;
  }
  if (error) {
    return <div style={{ textAlign: 'center', padding: '3rem', color: '#ff4444' }}>{error}</div>;
  }
  if (!filings.length) {
    return <div style={{ textAlign: 'center', padding: '3rem', color: '#475569' }}>No filings match these filters.</div>;
  }

  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div>
      {filings.map((f, i) => (
        f.locked
          ? <FilingLockedRow key={f.ticker + f.filedAt + i} filing={f} onSignIn={onSignIn} />
          : <FilingRow key={f.ticker + f.filedAt + i} filing={f} onNavigate={onNavigate} />
      ))}

      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '0.75rem', marginTop: '1.25rem' }}>
          <button onClick={() => onPageChange(page - 1)} disabled={page <= 1}
            style={{ padding: '0.5rem 1rem', background: 'rgba(0,212,255,0.08)',
              border: '1px solid rgba(0,212,255,0.2)', borderRadius: '8px', color: '#00d4ff',
              cursor: page <= 1 ? 'default' : 'pointer', opacity: page <= 1 ? 0.4 : 1, fontFamily: 'inherit' }}>
            ← Prev
          </button>
          <span style={{ fontSize: '0.8rem', color: '#64748b', alignSelf: 'center' }}>
            Page {page} of {totalPages}
          </span>
          <button onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}
            style={{ padding: '0.5rem 1rem', background: 'rgba(0,212,255,0.08)',
              border: '1px solid rgba(0,212,255,0.2)', borderRadius: '8px', color: '#00d4ff',
              cursor: page >= totalPages ? 'default' : 'pointer', opacity: page >= totalPages ? 0.4 : 1, fontFamily: 'inherit' }}>
            Next →
          </button>
        </div>
      )}
    </div>
  );
}
